import { toast } from "react-toastify";
import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    Card,
    CardBody,
    CardFooter,
    Col,
    Input,
    Label,
    Row,
    UncontrolledButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    Nav,
    NavLink,
} from "reactstrap";
import Dropdown from "react-dropdown-select";
import TransitionOnLoad from "Components/TransitionOnLoad";
import PageHeading from "Layout/AppMain/PageHeading";
import AppFooter from "Layout/AppFooter";
import VerzoekenSchemaTable from "./table";
import { ReactComponent as GrrayCircle } from "../../../../assets/utils/images/svgs/GrrayCircle.svg";
import { ReactComponent as Rood } from "../../../../assets/utils/images/svgs/Rood.svg";
import { ReactComponent as Groen } from "../../../../assets/utils/images/svgs/Groen.svg";
import { ReactComponent as Paars } from "../../../../assets/utils/images/svgs/Paars.svg";
import { ReactComponent as Oranje } from "../../../../assets/utils/images/svgs/Oranje.svg";
import { ReactComponent as Grijs } from "../../../../assets/utils/images/svgs/Grijs.svg";
import { useRequestList } from "Api/Coordinator/Verzoeken";
import { Loader } from 'react-loaders';

const getStoredValue = (key, defaultValue) => {
    try {
        const stored = sessionStorage.getItem(`verzoeken_${key}`);
        return stored ? JSON.parse(stored) : defaultValue;
    } catch {
        return defaultValue;
    }
};

const setStoredValue = (key, value) => {
    try {
        sessionStorage.setItem(`verzoeken_${key}`, JSON.stringify(value));
    } catch (error) {
        console.warn("Failed to store value in sessionStorage:", error);
    }
};

const getDropdownDisplayText = (
    selectedIds,
    list,
    placeholder,
    maxLength,
    idKey,
    labelKey
) => {
    if (!selectedIds || selectedIds.length === 0) {
        return placeholder;
    }

    if (selectedIds.length > 1) {
        return "Meerdere";
    }

    const selectedItem = list?.find(
        (item) => item[idKey] === selectedIds[0]
    );

    const label = selectedItem?.[labelKey] || placeholder;

    return label.length > maxLength
        ? `${label.substring(0, maxLength)}...`
        : label;
};

const Default = () => {
    const isPageReload = useRef(!sessionStorage.getItem("app_navigation_flag"));

    useEffect(() => {
        sessionStorage.setItem("app_navigation_flag", "true");

        const handleBeforeUnload = () => {
            sessionStorage.removeItem("app_navigation_flag");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const [countArray, setCountArray] = useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]);
    const [communityId, setCommunityId] = useState(() => getStoredValue("communityId", []));
    const [schoolId, setSchoolId] = useState(() => getStoredValue("schoolId", []));
    const [groupId, setGroupId] = useState(() => getStoredValue("groupId", []));
    const [limit, setLimit] = useState(() => getStoredValue("limit", ""));
    const [markerenColor, setMarkerenColor] = useState(() => getStoredValue("markerenColor", "all"));
    const [status, setStatus] = useState(() => getStoredValue("status", ["Openstaand"]));
    const [isFilter, setIsFilter] = useState(1);
    const [planning, setPlanning] = useState(() => getStoredValue("planning", 1));
    const [pageSizeCount, setPageSizeCount] = useState(() => {
        return getStoredValue("isTablePageChange", 0) === 0
            ? 1000
            : getStoredValue("pageSizeCount", 20);
    });
    const [pageNumber, setPageNumber] = useState(1);
    const [serachValue, setSerachValue] = useState("");
    const [colorDropdown, setColorDropdown] = useState(false);

    const buildRequestPayload = (f) => {

        const payload = {
            markerenColor: f.markerenColor,
            search: f.serachValue,
            limit: f.limit,
            planning: f.planning,
            page: f.pageNumber,
            pageSize: f.pageSizeCount,
            status: Array.isArray(f.status)
                ? f.status.join(",")
                : f.status,

            iGroupId: Array.isArray(f.groupId)
                ? f.groupId.join(",")
                : f.groupId,

            iSchoolId: Array.isArray(f.schoolId)
                ? f.schoolId.join(",")
                : String(f.schoolId),

            iCommunityId: Array.isArray(f.communityId)
                ? f.communityId.join(",")
                : String(f.communityId),
        };

        Object.keys(payload).forEach((key) => {
            const value = payload[key];

            const isEmptyArray =
                Array.isArray(value) && value.length === 0;

            const isEmptyString =
                value === "" || value === null || value === undefined;

            if (isEmptyArray || isEmptyString) {
                delete payload[key];
            }
        });

        return payload;
    };

    const requestFilters = {
        status,
        planning,
        communityId,
        schoolId,
        limit,
        groupId,
        serachValue,
        markerenColor,
        pageNumber,
        pageSizeCount,
    };

    const {
        trigger: getRequestList,
        data: requestResponse,
        isMutating,
        error,
    } = useRequestList();

    useEffect(() => {
        getRequestList({
            data: buildRequestPayload(requestFilters),
        });
    }, [
        status,
        planning,
        communityId,
        schoolId,
        limit,
        groupId,
        serachValue,
        markerenColor,
        pageNumber,
        pageSizeCount
    ]);

    useEffect(() => {
        if (error) {
            toast.error(
                error?.response?.message ||
                error?.message ||
                "Something went wrong"
            );
        }
    }, [error]);

    const requestData = requestResponse || {};
    const data = requestData || {};
    const schoolList = requestData?.schoolList || [];
    const totalPageCount = requestData?.data?.count || 1;
    const totalCount = requestData?.data?.totalCount

    useEffect(() => {
        if (isPageReload.current) {
            const filterKeys = [
                "communityId",
                "schoolId",
                "groupId",
                "limit",
                "markerenColor",
                "status",
                "planning",
                "search",
                "isTablePageChange",
                "pageSizeCount",
            ];

            filterKeys.forEach((key) => {
                sessionStorage.removeItem(`verzoeken_${key}`);
            });

            clearAllFilters();
        }
    }, []);

    const filterRequest = (statusValue, filter) => {
        const newValue = getStoredValue("isTablePageChange", 0) + 1;
        setStoredValue("isTablePageChange", newValue);

        const getStatus = [];
        let updatedStatus = [...status];
        const index = updatedStatus.indexOf(statusValue);

        let formData;

        if (index >= 0) {
            updatedStatus.splice(index, 1);
            setStatus(updatedStatus);
            formData = updatedStatus;
        } else {
            getStatus.push(...status, statusValue);
            setStatus(getStatus);
            formData = getStatus;
        }

        setStoredValue("status", formData);

        if (formData.includes("Afgesloten")) {
            if (pageSizeCount !== 20) {
                setPageSizeCount(20);
                return;
            }
        } else {
            if (pageSizeCount !== 1000) {
                setPageSizeCount(1000);
                return;
            }
        }

        if (filter == 1 && isFilter == 1) {
            setIsFilter(0);
        } else if (filter == 2 && isFilter == 2) {
            setIsFilter(5);
        } else if (filter == 3 && isFilter == 3) {
            setIsFilter(0);
        } else if (filter == 4 && isFilter == 4) {
            setIsFilter(0);
        } else {
            setIsFilter(filter);
        }
    };

    const userTablePageSize = (val) => {
        if (pageSizeCount !== val) {
            setPageSizeCount(val);
            setStoredValue("pageSizeCount", val);
        }
    };

    const handleCallback = (value, type) => {
        if (type === "communityId") {
            setCommunityId(value);
            setStoredValue("communityId", value);
        }
        if (type === "schoolId") {
            setSchoolId(value);
            setStoredValue("schoolId", value);
        }
        if (type === "groupId") {
            setGroupId(value);
            setStoredValue("groupId", value);
        }
        if (type === "limit") {
            setLimit(value);
            setStoredValue("limit", parseInt(value));
        }
        if (type === "planning") {
            setPlanning(value);
            setStoredValue("planning", value);
        }
        if (type === "markerenColor") {
            setMarkerenColor(value);
            setColorDropdown(false);
            setStoredValue("markerenColor", value);
        }
    };

    const paginate = (val) => {
        setPageNumber(val);
    };

    const handleInputChange = (val) => {
        const delay = 1000;

        const timeoutId = setTimeout(() => {
            setSerachValue(val);
            setStoredValue('search', val);
        }, delay);

        return () => {
            clearTimeout(timeoutId);
        };
    };

    const filterList = (val) => {
        handleInputChange(val);
    };

    const itemRenderer = ({ item, methods }, selectedIds) => {
        const isSelected =
            methods.isSelected(item) ||
            selectedIds.map(Number).includes(Number(item.value));

        return (
            <div
                key={item.value}
                className={`dropdown-item${isSelected ? " selected" : ""}`}
                onClick={() => methods.addItem(item)}
            >
                <input
                    type="checkbox"
                    checked={isSelected}
                    readOnly
                />
                {item.label}
            </div>
        );
    };

    const clearAllFilters = () => {
        setCommunityId([]);
        setSchoolId([]);
        setGroupId([]);
        setLimit("");
        setMarkerenColor("all");
        setStatus(["Openstaand"]);
        setPlanning(1);
        setSerachValue("");

        [
            "communityId",
            "schoolId",
            "groupId",
            "limit",
            "markerenColor",
            "status",
            "planning",
            "search",
            "isTablePageChange",
        ].forEach((key) => {
            sessionStorage.removeItem(`verzoeken_${key}`);
        });
    };


    return (
        <Fragment>
            <PageHeading />
            <div>
                <TransitionOnLoad>
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3 table-responsive">
                                    {isMutating ? (
                                        <div>
                                            <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center w-100'} />
                                        </div>
                                    ) : (
                                        <VerzoekenSchemaTable
                                            data={data?.data?.planingList ?? []}
                                            showLoader={isMutating}
                                            totalPageCount={totalPageCount}
                                            pageNumber={pageNumber}
                                            pageSizeCount={pageSizeCount}
                                            userTablePageSize={userTablePageSize}
                                            setPageNumber={setPageNumber}
                                            paginate={paginate}
                                            filterList={filterList}
                                            totalCount={totalCount}
                                            status={status}
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </TransitionOnLoad>

              <div className="chat-layout-footer verzoken-footer-height">
    <CardFooter className="d-block d-flex chat-layout-footer__inner">
        <div className="w-100">
            <Row className="verzoeken-footer-row">

                <Col md="8" className="verzoeken-filters-col">
                    <div className="mt-1 checbox-border">
                        <Row className="typeHead-CustomStyle verzoeken-filter-controls">

                            {/* Bestuur */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling ms-2">
                                    <div className="col-md-10 selectBy p-0">
                                        <Dropdown
                                            multi
                                            options={(data?.data?.communityList || []).map((item) => ({
                                                value: item.iCommunityId,
                                                label: item.name,
                                            }))}
                                            onChange={(e) => {
                                                setCommunityId(e.map((key) => key.value));
                                                handleCallback(e.map((key) => key.value), "communityId");
                                            }}
                                            itemRenderer={(props) => itemRenderer(props, communityId)}
                                            values={(data?.data?.communityList || [])
                                                .filter((item) => communityId.includes(item.iCommunityId))
                                                .map((item) => ({
                                                    value: item.iCommunityId,
                                                    label: item.name,
                                                }))}
                                            placeholder="Bestuur"
                                            dropdownPosition="top"
                                            closeOnScroll={true}
                                            className="custom-multiselector community-dropdown"
                                            closeOnSelect={false}
                                            keepSelectedInList={true}
                                            contentRenderer={() => (
                                                <div>
                                                    {getDropdownDisplayText(
                                                        communityId,
                                                        data?.data?.communityList || [],
                                                        "Bestuur",
                                                        12,
                                                        "iCommunityId",
                                                        "name"
                                                    )}
                                                </div>
                                            )}
                                            dropdownHandle={false}
                                            dropdownGap={5}
                                            noDataLabel="Geen opties beschikbaar"
                                            searchable={true}
                                        />
                                    </div>
                                </Row>
                            </Col>

                            {/* School */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling">
                                    <div className="col-md-10 selectBy p-0">
                                        <Dropdown
                                            multi
                                            options={(data?.data?.schoolList || []).map((item) => ({
                                                value: item.iSchoolId,
                                                label: item.vSchoolName,
                                            }))}
                                            onChange={(e) => {
                                                setSchoolId(e.map((key) => key.value));
                                                handleCallback(e.map((key) => key.value), "schoolId");
                                            }}
                                            itemRenderer={(props) => itemRenderer(props, schoolId)}
                                            values={(schoolList || [])
                                                .filter((item) => schoolId.includes(item.iSchoolId))
                                                .map((item) => ({
                                                    value: item.iSchoolId,
                                                    label: item.vSchoolName,
                                                }))}
                                            placeholder="School"
                                            dropdownPosition="top"
                                            closeOnScroll={true}
                                            closeOnSelect={false}
                                            keepSelectedInList={true}
                                            contentRenderer={() => (
                                                <div>
                                                    {getDropdownDisplayText(
                                                        schoolId,
                                                        data?.data?.schoolList || [],
                                                        "School",
                                                        12,
                                                        "iSchoolId",
                                                        "vSchoolName"
                                                    )}
                                                </div>
                                            )}
                                            dropdownHandle={false}
                                            dropdownGap={5}
                                            className="custom-multiselector community-dropdown"
                                            noDataLabel="Geen opties beschikbaar"
                                            searchable={true}
                                        />
                                    </div>
                                </Row>
                            </Col>

                            {/* Functie */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling">
                                    <div className="col-md-10 selectBy p-0 px-0">
                                        <Dropdown
                                            multi
                                            options={(data?.data?.groupList || []).map((item) => ({
                                                value: item.iSubGroupId,
                                                label: item.text,
                                            }))}
                                            onChange={(e) => {
                                                setGroupId(e.map((key) => key.value));
                                                handleCallback(e.map((key) => key.value), "groupId");
                                            }}
                                            itemRenderer={(props) => itemRenderer(props, groupId)}
                                            values={(data.groupList || [])
                                                .filter((item) => groupId.includes(item.iSubGroupId))
                                                .map((item) => ({
                                                    value: item.iSubGroupId,
                                                    label: item.text,
                                                }))}
                                            placeholder="Functie"
                                            dropdownPosition="top"
                                            closeOnScroll={true}
                                            closeOnSelect={false}
                                            keepSelectedInList={true}
                                            contentRenderer={() => (
                                                <div>
                                                    {getDropdownDisplayText(
                                                        groupId,
                                                        data?.data?.groupList || [],
                                                        "Functie",
                                                        20,
                                                        "iSubGroupId",
                                                        "text"
                                                    )}
                                                </div>
                                            )}
                                            dropdownHandle={false}
                                            dropdownGap={5}
                                            className="custom-multiselector community-dropdown"
                                            noDataLabel="Geen opties beschikbaar"
                                            searchable={true}
                                        />
                                    </div>
                                </Row>
                            </Col>

                            {/* Dagen */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling">
                                    <div className="col-md-10 selectBy p-0">
                                        <select
                                            className="form-select"
                                            value={limit}
                                            onChange={(event) =>
                                                handleCallback(event.target.value, "limit")
                                            }
                                        >
                                            <option value="">Dagen</option>
                                            {countArray.map((key) => (
                                                <option key={key} value={key}>
                                                    {key}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Row>
                            </Col>

                            {/* Alle kleuren */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling">
                                    <div className="col-md-10 selectBy p-0 color-dropdown community-dropdown">
                                        <UncontrolledButtonDropdown
                                            isOpen={colorDropdown}
                                            toggle={() => setColorDropdown((prev) => !prev)}
                                        >
                                            <div>
                                                <DropdownToggle color="link">
                                                    <span
                                                        className="color-btn"
                                                        style={{
                                                            color: colorDropdown ? "#026094" : "#878EA6",
                                                            borderColor: colorDropdown ? "#026094" : "#878EA6",
                                                        }}
                                                    >
                                                        {markerenColor === "all" ? (
                                                            "Alle kleuren"
                                                        ) : (
                                                            <GrrayCircle fill={markerenColor} />
                                                        )}
                                                    </span>
                                                </DropdownToggle>
                                            </div>

                                            <DropdownMenu className="rm-pointers dropdown-menu-lg verzoeken-dropdown">
                                                <span className="markeren-title">
                                                    Markeren
                                                </span>

                                                <Nav vertical>
                                                    <NavLink
                                                        className="link-gap "
                                                        onClick={() =>
                                                            handleCallback("all", "markerenColor")
                                                        }
                                                    >
                                                        <span>Alle kleuren</span>
                                                    </NavLink>

                                                    <NavLink
                                                        className="link-gap"
                                                        onClick={() =>
                                                            handleCallback("#878EA6", "markerenColor")
                                                        }
                                                    >
                                                        <span><Grijs /></span>
                                                        <span>Grijs</span>
                                                    </NavLink>

                                                    <NavLink
                                                        className="link-gap navlink-border"
                                                        onClick={() =>
                                                            handleCallback("#FF0000", "markerenColor")
                                                        }
                                                    >
                                                        <span><Rood /></span>
                                                        <span>Rood</span>
                                                    </NavLink>

                                                    <NavLink
                                                        className="link-gap navlink-border"
                                                        onClick={() =>
                                                            handleCallback("#008000", "markerenColor")
                                                        }
                                                    >
                                                        <span><Groen /></span>
                                                        <span>Groen</span>
                                                    </NavLink>

                                                    <NavLink
                                                        className="link-gap navlink-border"
                                                        onClick={() =>
                                                            handleCallback("#800080", "markerenColor")
                                                        }
                                                    >
                                                        <span><Paars /></span>
                                                        <span>Paars</span>
                                                    </NavLink>

                                                    <NavLink
                                                        className="link-gap navlink-border"
                                                        onClick={() =>
                                                            handleCallback("#FFA500", "markerenColor")
                                                        }
                                                    >
                                                        <span><Oranje /></span>
                                                        <span>Oranje</span>
                                                    </NavLink>
                                                </Nav>
                                            </DropdownMenu>
                                        </UncontrolledButtonDropdown>
                                    </div>
                                </Row>
                            </Col>

                            {/* Planning */}
                            <Col md="2" className="verzoeken-filter-col">
                                <Row className="form-checkbox-styling">
                                    <div className="col-md-10 selectBy p-0 px-0">
                                        <select
                                            className="form-select"
                                            value={planning}
                                            onChange={(event) =>
                                                handleCallback(event.target.value, "planning")
                                            }
                                        >
                                            <option value="">Planning</option>
                                            <option value="1">Centrale Planning</option>
                                            <option value="2">School Planning</option>
                                        </select>
                                    </div>
                                </Row>
                            </Col>

                        </Row>
                    </div>
                </Col>

                {/* Status checkboxes */}
                <Col md="4" className="verzoeken-status-col">
                    <div className="me-2">
                        <div className="d-flex align-items-center justify-content-between gap-2 mt-1 status-checkbox-row">

                            <div className="custom-checkbox status-checkbox">
                                <Label className="mb-0">
                                    Openstaand ({data?.data?.countList?.Openstaand ?? 0})
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="informSms"
                                    onChange={() => filterRequest("Openstaand", 1)}
                                    checked={status.indexOf("Openstaand") >= 0}
                                />
                            </div>

                            <div className="custom-checkbox status-checkbox">
                                <Label className="mb-0">
                                    Geparkeerd ({data?.data?.countList?.Geparkeerd ?? 0})
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="informSms"
                                    onChange={() => filterRequest("Geparkeerd", 2)}
                                    checked={status.indexOf("Geparkeerd") >= 0}
                                />
                            </div>

                            <div className="custom-checkbox status-checkbox">
                                <Label className="mb-0">
                                    Behandeld
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="informSms"
                                    onChange={() => filterRequest("Behandeld", 3)}
                                    checked={status.indexOf("Behandeld") >= 0}
                                />
                            </div>

                            <div className="custom-checkbox status-checkbox">
                                <Label className="mb-0">
                                    Afgesloten
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="informSms"
                                    onChange={() => filterRequest("Afgesloten", 4)}
                                    checked={status.indexOf("Afgesloten") >= 0}
                                />
                            </div>

                        </div>
                    </div>
                </Col>

            </Row>
        </div>
    </CardFooter>
</div>
            </div>

            {/* <AppFooter /> */}
        </Fragment>
    );
};

export default Default;